var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export function Edit(_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M4.5 15.5H5.5625L13.375 7.6875L12.3125 6.625L4.5 14.4375V15.5ZM3 17V13.8125L13.375 3.4375C13.5278 3.28472 13.6933 3.17361 13.8716 3.10417C14.0499 3.03472 14.2374 3 14.4341 3C14.6308 3 14.8194 3.03472 15 3.10417C15.1806 3.17361 15.3472 3.28472 15.5 3.4375L16.5625 4.5C16.7153 4.65278 16.8264 4.81944 16.8958 5C16.9653 5.18056 17 5.36487 17 5.55296C17 5.75357 16.9651 5.94478 16.8954 6.12658C16.8256 6.3084 16.7147 6.47454 16.5625 6.625L6.1875 17H3ZM12.8344 7.16556L12.3125 6.625L13.375 7.6875L12.8344 7.16556Z", fill: color }) })));
}
